// extracted by mini-css-extract-plugin
module.exports = {"link":"UiNavbar_link__4SrZ5","hover":"UiNavbar_hover__569du","rtl":"UiNavbar_rtl__kndDE","active":"UiNavbar_active__oNKLN"};